(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name quote.controller:QuoteCtrl
   *
   * @description
   *
   */
  angular
    .module('quote')
    .controller('QuoteCtrl', QuoteCtrl);

  QuoteCtrl.$inject = ['$scope', '$log', 'DataService', '_', 'incomingBrokerRef'];

  function QuoteCtrl($scope, $log, dataService, _, incomingBrokerRef) {
    var vm = this;
    vm.modelWatcher = null;
    vm.data = dataService.data;
    vm.updateQuoteType = updateQuoteType;
    vm.validationActive = false;
    vm.isQuoteValid = false;
    vm.getSbuWebsite = dataService.getSbuWebsite;
    vm.showQuoteResponse = showQuoteResponse;
    vm.isForwardButtonEnabled = isForwardButtonEnabled;
    vm.getQuoteResponseType = getQuoteResponseType;

    activate();
    function activate() {
      if (incomingBrokerRef.value && incomingBrokerRef.value.length > 0) {
        $log.debug('Incoming brokerref: ' + incomingBrokerRef.value);
        dataService.getBroker(incomingBrokerRef.value);
      }
      if (angular.isUndefined(vm.data.quoteDefinition)) {
        dataService.initialize();
      } else {
        initialize();
      }
    }

    function initialize() {
      createModelWatcher();
      vm.validationActive = true;
    }

    function updateQuoteType(quoteType) {
      $log.debug('Updating the quote type.');
      vm.validationActive = true;
      vm.isQuoteValid = false;
      if (validateSectionList(vm.data.viewModel.sectionList)) {
        vm.data.viewModel.selectedQuoteType = quoteType;
        preLoadBrokerList();
        if (vm.modelWatcher !== null) {
          $log.debug('Removing a modelWatcher');
          vm.modelWatcher();
        }
        createModelWatcher();
      } else {
        // We have invalid questions - no quote type selection is allowed
        vm.data.viewModel.selectedQuoteType = null;
      }
    }

    function preLoadBrokerList() {
      if (angular.isUndefined(vm.data.brokerList) || _.isEmpty(vm.data.brokerList)) {
        vm.data.brokerPostalCode = '' + dataService.getPostalCodeQuestion().answer;
        dataService.getBrokerList(vm.data.brokerPostalCode);
      }
    }

    function createModelWatcher() {
      $log.debug('Creating a viewModel watcher!');
      vm.modelWatcher = $scope.$watch('quote.data.viewModel', _.debounce(function () {
        $log.debug('viewModel watcher invoked.');
        if (validateSectionList(vm.data.viewModel.sectionList)) {
          if (vm.data.viewModel.selectedQuoteType) {
            vm.data.initiatedQuoteTypes[vm.data.viewModel.selectedQuoteType.definition.id] = true;
          }
          if (validateSectionList(vm.data.viewModel.selectedQuoteType.sectionList)) {
            vm.isQuoteValid = true;
            $scope.$apply(function () {
              dataService.sendQuoteRequest();
            });
          } else {
            $scope.$apply(function () {
              vm.isQuoteValid = false;
            });
          }
        }
      }, 1000), true);
    }

    function validateSectionList(sectionList) {
      $log.debug('Validate section list called.');
      return _.every(sectionList, function (section) {
        return _.every(section.instanceList, function (instance) {
          return _.every(instance.questionList, function (question) {
            if (!question.hidden && question.definition.attributes.required === 'true' &&
              (angular.isUndefined(question.answer) || question.answer === null)) {
              $log.debug('Invalid question detected! ' + question.definition.name);
              return false;
            }
            return true;
          });
        });
      });
    }

    function showQuoteResponse() {
      return vm.data.quoteResponse &&
      (vm.data.quoteResponse.data && vm.data.quoteResponse.data.status || vm.data.quoteResponse.error) &&
        angular.isDefined(vm.quoteForm) &&
        vm.quoteForm.$valid &&
        vm.data.viewModel.selectedQuoteType !== null &&
        vm.isQuoteValid;
    }

    function getQuoteResponseType() {
      if (vm.data.quoteResponse.data &&
          vm.isQuoteValid) {
        if (vm.data.quoteResponse.data.status === 'success') {
          return 'QUOTE_RESPONSE_SUCCESS';
        }
        return 'QUOTE_RESPONSE_UNSUCCESSFUL';
      }
      return 'QUOTE_RESPONSE_ERROR';
    }

    function isForwardButtonEnabled() {
      return vm.data.quoteResponse &&
        (vm.data.quoteResponse.data && vm.data.quoteResponse.data.showQuote) &&
        vm.isQuoteValid &&
        angular.isDefined(vm.quoteForm) &&
        vm.quoteForm.$valid;
    }
  }
}());
